import React from 'react';
import styled from 'styled-components/macro';

const Graphic = styled.div`
  position: relative;
  top: -1px;
  height: 192px;
  background-image: url(${props => props.src});
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
`;

const PageGraphic = ({ src }) => {
  return <Graphic src={src} />;
};

export default PageGraphic;
